import { Button, Grid, Paper, TableFooter, TablePagination } from "@material-ui/core";
import {
    createStyles, makeStyles,
    Theme, withStyles
} from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { Edit } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
    getInstitute
} from "../../actions/GenomicsResearchAction";
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        table: {
            minWidth: 700,
        },
        hoveItem: {
            cursor: "pointer",
        },
        chips: {
            display: "flex",
        },
        chip: {
            margin: 2,
            background: "linear-gradient(60deg, cyan, #00cfff, cyan)",
            maxWidth: "130px",
        },
        input: {
            padding: "1px",
        },
        tableContainer: {
            marginTop: "2rem",
            position: "sticky",
            top: "200px",
        },
    })
);

const StyledTableCell: any = withStyles((theme: Theme) =>
    createStyles({
        head: {
            backgroundColor: "#12145e",
            color: theme.palette.common.white,
            fontSize: "14px",
        },
        body: {
            fontSize: 14,
        },
    })
)(TableCell);

const StyledTableRow: any = withStyles((theme: Theme) =>
    createStyles({
        root: {
            "&:nth-of-type(odd)": {
                backgroundColor: theme.palette.action.hover,
            },
        },
    })
)(TableRow);
interface Props {
    getInstitute: any;
    institute: any;
    setInstituteId: any;
    setOnboardingActionType: any;
    setValue: any;
}
const StopsPlace: React.FC<Props> = ({
    getInstitute,
    institute,
    setInstituteId,
    setOnboardingActionType,
    setValue,

}) => {
    const classes = useStyles();
    const [page, setPage] = useState(0);

    useEffect(() => {
        getInstitute();
    }, []);

    const handleChangePage = (
        event: React.MouseEvent<HTMLButtonElement> | null,
        newPage: number
    ) => {
        if (newPage > page) {
            let url = institute.links && institute.links.next.split("?")[1];
            getInstitute(`?${url}`);
        } else if (newPage < page) {
            let url = institute.links && institute.links.previous.split("?")[1];
            getInstitute(`${url === undefined ? "" : "?" + url}`);
        }
        setPage(newPage);
    };
    return (
        <Grid container spacing={2} style={{ marginTop: 10 }}>
            <Grid container style={{ marginTop: 10 }}>
                <TableContainer
                    className={classes.tableContainer}
                    component={Paper}
                    style={{ maxHeight: "480px" }}
                >
                    <Table stickyHeader aria-label="simple table">
                        <TableHead>
                            <StyledTableRow>
                                <StyledTableCell align="center">Institute Name</StyledTableCell>
                                <StyledTableCell align="center">Institute Email</StyledTableCell>
                                <StyledTableCell align="center">Address of Institute</StyledTableCell>
                                <StyledTableCell align="center">Area</StyledTableCell>
                                <StyledTableCell align="center">Institute Contact Person</StyledTableCell>
                                <StyledTableCell align="center">Edit</StyledTableCell>
                            </StyledTableRow>
                        </TableHead>
                        <TableBody>
                            {institute && institute?.results && institute?.results?.length > 0 && institute?.results?.map((data: any, index: any) => {
                                return (
                                    <StyledTableRow >
                                        <StyledTableCell align="center">
                                            {data?.name}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {data?.email}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {data?.address}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {data?.city?.name}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {data?.contactPerson}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            <Button
                                                color="primary"
                                                variant="contained"
                                            >
                                                <Edit onClick={() => {
                                                    setInstituteId(data)
                                                    setValue(1)
                                                    setOnboardingActionType("Edit Onboard Institute")
                                                }} />
                                            </Button>
                                        </StyledTableCell>
                                    </StyledTableRow>
                                )
                            })}
                        </TableBody>
                        <TableFooter>
                            <TablePagination
                                rowsPerPageOptions={[]}
                                colSpan={3}
                                count={institute?.count || 0}
                                rowsPerPage={institute?.page_size}
                                page={page}
                                onPageChange={handleChangePage}
                            />
                        </TableFooter>
                    </Table>
                </TableContainer>
            </Grid>
        </Grid>
    );
};
const mapStateToProps = (state: any) => ({
    institute: state.GenomicsCAReducer.institute,
});
export default connect(mapStateToProps, {
    getInstitute,
})(StopsPlace);